/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { GetGroupStatisticQueryResult } from '../model/getGroupStatisticQueryResult';
import { GetUserStatisticQueryResult } from '../model/getUserStatisticQueryResult';
import { GpiGroupStatisticsModel } from '../model/gpiGroupStatisticsModel';
import { InlineResponse404 } from '../model/inlineResponse404';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class StatisticService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [MOBILE] Gets group GPI statistics
     * Members&#x27; average GPI per day with its running total and the members&#x27; average pillar levels for a Friends group the caller belongs to; null below 3 members with a value. Never an individual member&#x27;s values.
     * @param groupUid 
     * @param days 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public statisticGetGroupGpiStatisticsGet(groupUid?: string, days?: number, observe?: 'body', reportProgress?: boolean): Observable<GpiGroupStatisticsModel>;
    public statisticGetGroupGpiStatisticsGet(groupUid?: string, days?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GpiGroupStatisticsModel>>;
    public statisticGetGroupGpiStatisticsGet(groupUid?: string, days?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GpiGroupStatisticsModel>>;
    public statisticGetGroupGpiStatisticsGet(groupUid?: string, days?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (groupUid !== undefined && groupUid !== null) {
            queryParameters = queryParameters.set('GroupUid', <any>groupUid);
        }
        if (days !== undefined && days !== null) {
            queryParameters = queryParameters.set('Days', <any>days);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GpiGroupStatisticsModel>('get',`${this.basePath}/Statistic/GetGroupGpiStatistics`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets group statistic for current user
     * CurrentUser geting statistic for GroupUid within a passed DateRange. Also calling GetUserStatisticHandler
     * @param groupUid 
     * @param startDateLocal 
     * @param endDateLocal 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public statisticGetGroupStatisticsGet(groupUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<GetGroupStatisticQueryResult>;
    public statisticGetGroupStatisticsGet(groupUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetGroupStatisticQueryResult>>;
    public statisticGetGroupStatisticsGet(groupUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetGroupStatisticQueryResult>>;
    public statisticGetGroupStatisticsGet(groupUid?: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (groupUid !== undefined && groupUid !== null) {
            queryParameters = queryParameters.set('GroupUid', <any>groupUid);
        }
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetGroupStatisticQueryResult>('get',`${this.basePath}/Statistic/GetGroupStatistics`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets statistic for current user
     * Handler called in GetGroupStatistic
     * @param startDateLocal 
     * @param endDateLocal 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public statisticGetUserStatisticsGet(startDateLocal?: string, endDateLocal?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserStatisticQueryResult>;
    public statisticGetUserStatisticsGet(startDateLocal?: string, endDateLocal?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserStatisticQueryResult>>;
    public statisticGetUserStatisticsGet(startDateLocal?: string, endDateLocal?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserStatisticQueryResult>>;
    public statisticGetUserStatisticsGet(startDateLocal?: string, endDateLocal?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserStatisticQueryResult>('get',`${this.basePath}/Statistic/GetUserStatistics`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
